import { ProgrammeSummaryActionDispatch, ProgrammeSummaryReduxTypes } from "./types";

export const createProgrammeSummary = (payload: any): ProgrammeSummaryActionDispatch => (
    {
    type: ProgrammeSummaryReduxTypes.PROGRAMME_SUMMARY_REPORT,
    payload: payload
})